import { render, staticRenderFns } from "./B-4-1-1__CSRPageEdit_ProjectFilter.vue?vue&type=template&id=fceb3ef8&"
import script from "./B-4-1-1__CSRPageEdit_ProjectFilter.vue?vue&type=script&lang=js&"
export * from "./B-4-1-1__CSRPageEdit_ProjectFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VTextField})
